import Image from 'next/image';
import Link from 'next/link'
import { useEffect, useState } from 'react';

export default function Footer() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 0;
            setScrolled(isScrolled);
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
    <footer className='footer-nav'>
        <div className='footer-container'>
            <div className='footer-logo'>
                <img src='/images/logo.png' alt='proslv'></img>
                <span className='footer-address'>#61 liamzon st midtown 3 subd. Brgy san roque marikina city</span>
                <span className='footer-email'>(02) 86567856</span>
            </div>
            <div className='footer-section'>
                <h3>Company</h3>
                <ul>
                    <li><Link href='/about'>About Us</Link></li>
                    <li><Link href='/contact'>Contact Us</Link></li>
                    {/* <li><Link href='/blog'>Blog</Link></li> */}
                </ul>
            </div>
            <div className='footer-section'>
                <h3>Solutions</h3>
                <ul>
                    <li><Link href='/solutions/video'>Video</Link></li>
                    <li><Link href='/solutions/sounds'>Sounds</Link></li>
                    <li><Link href='/solutions/lighting'>Lighting</Link></li>
                    <li><Link href='/solutions/system'>System Integration</Link></li>
                </ul>
            </div>
            {/* <div className='footer-section'>
                <h3>Resources</h3>
                <ul>
                    <li><Link href='/resources'>Resource 1</Link></li>
                    <li><Link href='/resources'>Resource 2</Link></li>
                    <li><Link href='/resources'>Resource 3</Link></li>
                </ul>
            </div> */}
            <div className='footer-section'>
                <h3>Legal</h3>
                <ul>
                    <li><Link href='/privacy'>Privacy Policy</Link></li>
                    <li><Link href='/terms'>Terms of Service</Link></li>
                    <li><Link href='/cookies'>Cookies Policy</Link></li>
                </ul>
            </div>
            <div className='footer-section'>
                <h3>Follow Us</h3>
                <ul>
                    <li><Link href='https://www.facebook.com/profile.php?id=100009751877436'>Facebook</Link></li>
                    {/* <li><Link href='https://www.twitter.com'>Twitter</Link></li>
                    <li><Link href='https://www.instagram.com'>Instagram</Link></li> */}
                </ul>
            </div>
        </div>
    </footer>
    )
}